import React from 'react';
import { Tooltip, Typography } from '@mui/material';

const TotalCell = React.memo(
  (
    { total }: { total: number } // Changed from => { return (...); } to => (...)
  ) => (
    <Tooltip arrow title={total.toFixed(0)}>
      <Typography
        variant="body2"
        noWrap
        onClick={() => {
          // Your click handling logic goes here
          console.log('Typography clicked! Total value:', total);
          // For example, open a dialog, navigate, or perform an action
        }}
      >
        {total}
      </Typography>
    </Tooltip>
  )
); // Added closing parenthesis here

export default TotalCell;
